import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LandingPage from './pages/LandingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import MSAPage from './pages/MSAPage';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import StorePage from './pages/StorePage';
import MarketplacePage from './pages/MarketplacePage';
import PlayPage from './pages/PlayPage';

import NotFoundPage from './pages/NotFoundPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import ForbiddenPage from './pages/ForbiddenPage';
import ServerErrorPage from './pages/ServerErrorPage';
import MaintenancePage from './pages/MaintenancePage';

import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { useTheme } from './context/ThemeContext';

// Maintenance gate — set REACT_APP_MAINTENANCE=true in the frontend .env
// (then rebuild) to take the entire app offline behind the 503 page.
// We bypass the gate when the URL is exactly `/maintenance` so the page
// can be linked / previewed without flipping the flag.
const isMaintenance = String(process.env.REACT_APP_MAINTENANCE || '').toLowerCase() === 'true';

function App() {
  const { theme } = useTheme();

  if (isMaintenance && typeof window !== 'undefined' && window.location.pathname !== '/maintenance') {
    return (
      <div className={`app ${theme}`}>
        <MaintenancePage />
      </div>
    );
  }

  return (
    <div className={`app ${theme}`}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/msa" element={<MSAPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route path="/store" element={<StorePage />} />
        <Route path="/play" element={<PlayPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />

        {/* Status pages — addressable so guards can navigate here and
            links can be shared when something specific went wrong. */}
        <Route path="/401" element={<UnauthorizedPage />} />
        <Route path="/403" element={<ForbiddenPage />} />
        <Route path="/500" element={<ServerErrorPage />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/404" element={<NotFoundPage />} />

        {/* Catch-all 404 — render the page instead of silently bouncing
            the user to the homepage. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme}
      />
    </div>
  );
}

export default App;
